__webpack_require__.p = "/getting-started/referrals-hub/";